import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { Grid } from '@mui/material';
import { useMeetingTypesQuery } from 'gql/index';
import React from 'react';
import { MeetingTypeCard } from '../MeetingTypeCard';

type Props = {
  onSelected: (id: number) => void;
};

export const MeetingTypeSelector: React.FC<Props> = ({ onSelected }) => {
  const { projectId } = useCurrentProject();

  const { data: meetingTypes } = useMeetingTypesQuery({ projectId }, { select: d => d.meetingTypes });

  return <>
    <Grid container spacing={4}>
      {meetingTypes?.map(meetingType =>
        <Grid size={{ xs: 12, sm: 6 }} key={meetingType.id}>
          <MeetingTypeCard
            meetingType={meetingType}
            onClick={() => onSelected(meetingType.id)}
          />
        </Grid>
      )}
    </Grid>
  </>;
};